module.exports = __webpack_public_path__ + "static/media/1274_CareTeam10_photo.b97a0726.png";